import gql from 'graphql-tag'
import {
  PRODUCT_AVAILABILITY_FRAGMENT,
  PRODUCT_ESTIMATED_DELIVERY_FRAGMENT,
} from '~/graphql/gql/product/fragments'

export const GET_PRODUCTS_VARIANT_BY_IDS = gql`
  query getProductVariantsByIdsForGtm(
    $ids: [ID!]!
    $withGifts: Boolean = false
    $withBundles: Boolean = false
  ) {
    products: getProductVariantsByIds(ids: $ids) {
      id
      title
      division
      productTypeId
      rank {
        count
        rank
      }
      mainCategoryUrlKey
      mainMenuUrlKey
      variants {
        brief
        id
        title
        labels
        price
        vatRate
        discountPrice
        priceRrp
        priceType
        rrpSavePercent
        defaultActualPrice
        discountPromotionPrice
        mainMenuPath
        availableOutlets
        availability {
          ...productAvailabilityFragment
        }
        estimatedDeliveries {
          ...productEstimatedDeliveryFragment
        }
        brand {
          title
        }
        mediaIds
        variantUrl
        isAvailable

        giftDetails @include(if: $withGifts) {
          variants {
            count
            variant {
              price
            }
          }
        }
        bundles @include(if: $withBundles) {
          ... on BaseProductBundle {
            type
            variants {
              id
              yearsNumber
            }
          }
        }
      }
      marketplace {
        marketplacePartnerTitle
        marketplacePartnerId
      }
    }
  }

  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`

export const GET_PRODUCTS_VARIANT_BY_IDS_CROSS_SELL = gql`
  query getProductVariantsByIdsForCrossSell($ids: [ID!]!) {
    products: getProductVariantsByIds(ids: $ids) {
      id
      variants {
        id
        recommendedVariants
      }
    }
  }
`
